import { render, staticRenderFns } from "./EdicaoTable.vue?vue&type=template&id=5e322486"
import script from "./EdicaoTable.vue?vue&type=script&lang=js"
export * from "./EdicaoTable.vue?vue&type=script&lang=js"
import style0 from "./EdicaoTable.vue?vue&type=style&index=0&id=5e322486&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports